export default __webpack_public_path__ + "static/media/sketch-worldcup-header.efb9e78f.png";